module.exports = __webpack_public_path__ + "static/img/time-attendance-icon.0aec6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/time-attendance-icon.png
// module id = XcBi
// module chunks = 0